/**
 * useBreakpoint — responsive breakpoint hook.
 *
 * Usage:
 *   const { isMobile, isTablet, isDesktop } = useBreakpoint();
 */

import { useWindowDimensions } from 'react-native';
import { Breakpoints } from '../theme/tokens';

export interface BreakpointResult {
  width:     number;
  isMobile:  boolean;   // < 640px
  isTablet:  boolean;   // 640–1023px
  isDesktop: boolean;   // ≥ 1024px
}

export const useBreakpoint = (): BreakpointResult => {
  const { width } = useWindowDimensions();
  return {
    width,
    isMobile:  width < Breakpoints.sm,
    isTablet:  width >= Breakpoints.sm && width < Breakpoints.lg,
    isDesktop: width >= Breakpoints.lg,
  };
};
